import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import BreadcrumbsSimple from '~/components/common/BreadcrumbSimple';
import Button from '~/components/common/Button';
import PageHeaderMeta from '~/components/common/PageHeaderMeta';
import useWindowSize from '~/components/hooks/useWindowSize';
import { ReactComponent as ArrowIcon } from '~/images/arrow-right.svg';
import { ReactComponent as EpistrofesIcon } from '~/images/black-friday/epistrofes.svg';
import { ReactComponent as FaqIcon } from '~/images/black-friday/faq-icon.svg';
import { ReactComponent as ShippingIcon } from '~/images/black-friday/shipping.svg';
/* HEROSLIDER SECTION */
/* HEROSLIDER SECTION */

/* GENERIC */
import bfBannerDesktop from '~/images/black-friday/bf-banner-desktop.png';
import bfBannerMobile from '~/images/black-friday/bf-banner-mobile.png';
import blackFridayText from '~/images/black-friday/black-friday-text.png';
import WaveBg from '~/images/black-friday/wave1.svg';
/* GENERIC ENDS */

/* MEN SECTION */
import menClothes from '~/images/black-friday/men-clothes.png';
import menShoes from '~/images/black-friday/men-shoes.png';
import menSneakers from '~/images/black-friday/men-sneakers.png';
import menIcon from '~/images/black-friday/men.png';
/* MEN SECTION ENDS */

/* WOMEN SECTION */
import womenClothes from '~/images/black-friday/women-clothes.png';
import womenShoes from '~/images/black-friday/women-shoes.png';
import womenShoes2 from '~/images/black-friday/women-shoes2.png';
import womenShoes3 from '~/images/black-friday/women-shoes3.png';
import womenIcon from '~/images/black-friday/women.png';
/* WOMEN SECTION ENDS */

/* KIDS SECTION */
import kidsShoes1 from '~/images/black-friday/kids-shoes1.png';
import kidsShoes2 from '~/images/black-friday/kids-shoes2.png';
import kidsIcon from '~/images/black-friday/kids.png';
/* KIDS SECTION ENDS */

/* TOP BRANDS SECTION */
import { Link } from 'react-router-dom';
import asicsBrand from '~/images/black-friday/asics.png';
import oneilBrand from '~/images/black-friday/oneil.png';
import reebokLogo from '~/images/black-friday/reebok-logo.png';
import speedoBrand from '~/images/black-friday/speedo.png';
import tevaBrand from '~/images/black-friday/teva.png';
/* TOP BRANDS SECTION ENDS */

const jsonFaqs = [
	{
		question: 'Τι είναι η Black Friday;',
		answer:
			'Η Black Friday είναι μια δημοφιλής εκδήλωση εκπτώσεων και προσφορών που ξεκίνησε στις Ηνωμένες Πολιτείες. Συνήθως πέφτει την ημέρα μετά την Ημέρα των Ευχαριστιών, που είναι η τέταρτη Πέμπτη του Νοεμβρίου. Την Black Friday, πολλοί έμποροι λιανικής προσφέρουν σημαντικές εκπτώσεις και προσφορές σε διάφορα προϊόντα, καθιστώντας την μια από τις πιο πολυσύχναστες ημέρες αγορών του χρόνου.'
	},
	{
		question: 'Πότε είναι η Black Friday το 2025;',
		answer:
			'Η Black Friday το 2025 θα πέσει στις 28 Νοεμβρίου, όπως παραδοσιακά γιορτάζεται την τέταρτη Παρασκευή του Νοεμβρίου. Ωστόσο, οι συγκεκριμένες ημερομηνίες μπορεί να διαφέρουν ανά έτος.'
	},
	{
		question: 'Πότε ξεκίνησε στην Ελλάδα η Black Friday;',
		answer:
			'Η Black Friday έχει κερδίσει δημοτικότητα στην Ελλάδα τα τελευταία χρόνια, με πολλούς εμπόρους λιανικής να υιοθετούν την παράδοση να προσφέρουν εκπτώσεις και προσφορές. Ωστόσο, δεν είναι τόσο βαθιά ριζωμένο στην ελληνική κουλτούρα όσο σε ορισμένες άλλες χώρες, όπως τις Ηνωμένες Πολιτείες.'
	},
	{
		question: 'Πώς θα μαθαίνω πρώτος τις hot προσφορές Black Friday;',
		answer:
			'Για να είστε από τους πρώτους που θα μάθετε για τις προσφορές της Black Friday στο Sportistas… Εγγραφείτε με 1 κλικ στο Black Friday Newsletter μας. Ακολουθήστε το Sportistas στα social media για ενημερώσεις και ανακοινώσεις. Επισκεφθείτε το ηλεκτρονικό μας κατάστημα και ενημερωθείτε.'
	},
	{
		question: 'Μέχρι πότε ισχύουν οι προσφορές Black Friday στα αθλητικά είδη;',
		answer:
			'Οι προσφορές της Black Friday για αθλητικά είδη μπορεί να διαφέρουν ανάλογα με το κατάστημα λιανικής, αλλά συχνά επεκτείνονται όλο το Σαββατοκύριακο, συμπεριλαμβανομένης της Cyber Monday. Τα συγκεκριμένα προϊόντα που πωλούνται στο Sportistas.com κατά τη διάρκεια της Black Friday θα εξαρτηθούν από τις προσφορές και το απόθεμά τους. Για να μείνετε ενημερωμένοι εγγραφείτε εύκολα στο newsletter μας και ακολουθήστε όλες τις προσφορές της Black Friday περιόδου.'
	},
	{
		question: 'Tι προϊόντα σε προσφορά θα βρω στο Sportistas στην Black Friday;',
		answer:
			'Την Black Friday στο Sportistas, μπορείτε να περιμένετε να ειδικές προσφορές και εκπτώσεις σε μια μεγάλη γκάμα προϊόντων από, Asics, O’neil, teva και speedo. Συγκεκριμένα, το Sportistas θα διαθέτει μεγάλες εκπτώσεις και προσφορές σε όλες τις συλλογές και μοντέλα Asics για άνδρες, γυναίκες και παιδιά. Αυτό σημαίνει απίθανες προσφορές για αθλητικά παπούτσια Asics, ρούχα και αξεσουάρ για όλη την οικογένεια. Αν είστε λάτρης των προϊόντων Asics, η Black Friday στο Sportistas θα είναι μια εξαιρετική ευκαιρία. Για τις ακριβείς λεπτομέρειες των προσφορών και των συγκεκριμένων προϊόντων που περιλαμβάνονται, επισκεφτείτε το Sportistas.com ή εγγραφείτε στο newsletter μας.'
	},
	{
		question: 'Τι προσφορές σε αθλητικά ρούχα θα βρω στο sportistas;',
		answer:
			'Στο Sportists, είμαστε αφοσιωμένοι στο να παρέχουμε μια ευρεία γκάμα αθλητικών ενδυμάτων υψηλής ποιότητας για να σας βοηθήσουμε να αποδώσετε τα μέγιστα και να φαίνεστε υπέροχα ενώ το κάνετε. Η συλλογή μας περιλαμβάνει μια σειρά από προσφορές προσαρμοσμένες στις ανάγκες σας σε αθλητικά ρούχα. Επιλέξτε ανάμεσα από φανταστικές προσφορές σε αθλητικά ρούχα και αξεσουάρ. Για το τένις, το βόλεϊ, το τρέξιμο την κολύμβηση και όποιο άθλημα σου ταιριάζει.'
	},
	{
		question: 'Τι προσφορές σε αθλητικά παπούτσια θα βρω στο sportistas;',
		answer:
			'Στο Sportists, κατανοούμε τη σημασία του να έχετε τα σωστά παπούτσια για κάθε αθλητική σας δραστηριότητα. Είτε είσαι δρομέας, λάτρης της φυσικής κατάστασης ή κάποιος που απλά λατρεύει τα κομψά αθλητικά παπούτσια, μια σειρά από φανταστικές προσφορές σε αθλητικά παπούτσια για τρέξιμο, τένις, padel ή απλό περπάτημα είναι εδώ για εσένα από το sportistas.'
	}
];

const faqSchema = {
	'@context': 'https://schema.org',
	'@type': 'FAQPage',
	'mainEntity': jsonFaqs.map((faq, index) => ({
		'@type': 'Question',
		'name': faq.question,
		'acceptedAnswer': {
			'@type': 'Answer',
			'text': faq.answer
		}
	}))
};

const BlackFriday = () => {
	const { t } = useTranslation();
	const { width } = useWindowSize();
	const [activeQuestion, setActiveQuestion] = useState(null);

	const whyItems = [
		{ img: <ShippingIcon />, title: 'ΔΩΡΕΑΝ ΜΕΤΑΦΟΡΙΚΑ', description: 'Άνω των 49€' },
		{ img: <EpistrofesIcon />, title: 'ΔΩΡΕΑΝ ΑΛΛΑΓΕΣ', description: 'Για την Αττική' }
	];

	const htmlFaqs = [
		{
			question: 'Τι είναι η Black Friday;',
			answer: (
				<p>
					Η Black Friday είναι μια δημοφιλής εκδήλωση εκπτώσεων και προσφορών που ξεκίνησε στις Ηνωμένες Πολιτείες. Συνήθως πέφτει την ημέρα
					μετά την Ημέρα των Ευχαριστιών, που είναι η τέταρτη Πέμπτη του Νοεμβρίου. Την Black Friday, πολλοί έμποροι λιανικής προσφέρουν
					σημαντικές εκπτώσεις και προσφορές σε διάφορα προϊόντα, καθιστώντας την μια από τις πιο πολυσύχναστες ημέρες αγορών του χρόνου.
				</p>
			)
		},
		{
			question: 'Πότε είναι η Black Friday το 2025;',
			answer: (
				<p>
					Η Black Friday το 2025 θα πέσει στις 28 Νοεμβρίου, όπως παραδοσιακά γιορτάζεται την τέταρτη Παρασκευή του Νοεμβρίου. Ωστόσο, οι
					συγκεκριμένες ημερομηνίες μπορεί να διαφέρουν ανά έτος.
				</p>
			)
		},
		{
			question: 'Πότε ξεκίνησε στην Ελλάδα η Black Friday;',
			answer: (
				<p>
					Η Black Friday έχει κερδίσει δημοτικότητα στην Ελλάδα τα τελευταία χρόνια, με πολλούς εμπόρους λιανικής να υιοθετούν την παράδοση
					να προσφέρουν εκπτώσεις και προσφορές. Ωστόσο, δεν είναι τόσο βαθιά ριζωμένο στην ελληνική κουλτούρα όσο σε ορισμένες άλλες χώρες,
					όπως τις Ηνωμένες Πολιτείες.
				</p>
			)
		},
		{
			question: 'Πώς θα μαθαίνω πρώτος τις hot προσφορές Black Friday;',
			answer: (
				<>
					<p>Για να είστε από τους πρώτους που θα μάθετε για τις προσφορές της Black Friday στο Sportistas…</p>
					<ul>
						<li>Εγγραφείτε με 1 κλικ στο Black Friday Newsletter μας.</li>
						<li>Ακολουθήστε το Sportistas στα social media για ενημερώσεις και ανακοινώσεις.</li>
						<li>Επισκεφθείτε το ηλεκτρονικό μας κατάστημα και ενημερωθείτε</li>
					</ul>
				</>
			)
		},
		{
			question: 'Μέχρι πότε ισχύουν οι προσφορές Black Friday στα αθλητικά είδη;',
			answer: (
				<p>
					Οι προσφορές της Black Friday για αθλητικά είδη μπορεί να διαφέρουν ανάλογα με το κατάστημα λιανικής, αλλά συχνά επεκτείνονται όλο
					το Σαββατοκύριακο, συμπεριλαμβανομένης της Cyber Monday. Τα συγκεκριμένα προϊόντα που πωλούνται στο Sportistas.com κατά τη
					διάρκεια της Black Friday θα εξαρτηθούν από τις προσφορές και το απόθεμά τους. Για να μείνετε ενημερωμένοι εγγραφείτε εύκολα στο
					newsletter μας και ακολουθήστε όλες τις προσφορές της Black Friday περιόδου.
				</p>
			)
		},
		{
			question: 'Tι προϊόντα σε προσφορά θα βρω στο Sportistas στην Black Friday;',
			answer: (
				<p>
					Την Black Friday στο Sportistas, μπορείτε να περιμένετε ειδικές προσφορές και εκπτώσεις σε μια μεγάλη γκάμα προϊόντων από, ASICS,
					O’neil, Teva και Speedo.
					<br />
					<br />
					Συγκεκριμένα, το Sportistas θα διαθέτει μεγάλες εκπτώσεις και προσφορές σε όλες τις συλλογές και μοντέλα Asics για άνδρες,
					γυναίκες και παιδιά. Αυτό σημαίνει απίθανες προσφορές για αθλητικά παπούτσια Asics, ρούχα και αξεσουάρ για όλη την οικογένεια.
					<br />
					<br />
					Αν είστε λάτρης των προϊόντων Asics, η Black Friday στο Sportistas θα είναι μια εξαιρετική ευκαιρία. Για τις ακριβείς λεπτομέρειες
					των προσφορών και των συγκεκριμένων προϊόντων που περιλαμβάνονται, επισκεφτείτε το Sportistas.com ή εγγραφείτε στο newsletter μας.
				</p>
			)
		},
		{
			question: 'Τι προσφορές σε αθλητικά ρούχα θα βρω στο Sportistas;',
			answer: (
				<p>
					Στο Sportists, είμαστε αφοσιωμένοι στο να παρέχουμε μια ευρεία γκάμα αθλητικών ενδυμάτων υψηλής ποιότητας για να σας βοηθήσουμε να
					αποδώσετε τα μέγιστα και να φαίνεστε υπέροχα ενώ το κάνετε.
					<br />
					<br />
					Η συλλογή μας περιλαμβάνει μια σειρά από προσφορές προσαρμοσμένες στις ανάγκες σας σε αθλητικά ρούχα.
					<br />
					<br />
					Επιλέξτε ανάμεσα από φανταστικές προσφορές σε αθλητικά ρούχα και αξεσουάρ. Για το τένις, το βόλεϊ, το τρέξιμο την κολύμβηση και
					όποιο άθλημα σου ταιριάζει.
				</p>
			)
		},
		{
			question: 'Τι προσφορές σε αθλητικά παπούτσια θα βρω στο Sportistas;',
			answer: (
				<p>
					Στο Sportists, κατανοούμε τη σημασία του να έχετε τα σωστά παπούτσια για κάθε αθλητική σας δραστηριότητα.
					<br />
					<br />
					Είτε είσαι δρομέας, λάτρης της φυσικής κατάστασης ή κάποιος που απλά λατρεύει τα κομψά αθλητικά παπούτσια, μια σειρά από
					φανταστικές προσφορές σε αθλητικά παπούτσια για τρέξιμο, τένις, padel ή απλό περπάτημα είναι εδώ για εσένα από το sportistas.
				</p>
			)
		}
	];

	const ribonBaseItems = [
		{
			className: 'asics',
			img: asicsBrand,
			alt: 'asics'
		},
		{
			className: 'bf',
			img: blackFridayText,
			alt: 'black friday'
		},
		{
			className: 'reebok',
			img: reebokLogo,
			alt: 'Reebok'
		}
	];

	const ribonItems = Array.from({ length: 10 }).flatMap(() => ribonBaseItems);

	return (
		<>
			<PageHeaderMeta
				page_title={t('black_friday_meta_title')}
				meta_description={t('black_friday_meta_description')}
				faq_schema={faqSchema}
			/>
			<div id="black-friday">
				<div className="content-wrapper">
					<BreadcrumbsSimple currentName="Black Friday" />
				</div>
				<div className="hero-banner">
					<img
						src={width < 768 ? bfBannerMobile : bfBannerDesktop}
						alt="Black Friday Banner"
						style={{
							width: '100%',
							height: 'auto',
							display: 'block'
						}}
					/>
				</div>
				<div className="banner">
					<div className="marquee-images">
						<Swiper
							autoplay={{
								delay: 0.1,
								disableOnInteraction: false
							}}
							speed={5000}
							spaceBetween={20}
							slidesPerView={5}
							breakpoints={{
								0: {
									slidesPerView: 'auto',
									spaceBetween: 50
								},
								425: {
									slidesPerView: 'auto',
									spaceBetween: 100
								},
								680: {
									slidesPerView: 3,
									spaceBetween: 50
								},
								1024: {
									slidesPerView: 4
								},
								1280: {
									slidesPerView: 5
								},
								1420: {
									slidesPerView: 6
								},
								2160: {
									slidesPerView: 6
								}
							}}
							modules={[Autoplay]}
							className="BrandsSwiper">
							{ribonItems.map((x, index) => (
								<SwiperSlide key={index}>
									<img className={x.className} src={x.img} alt={x.alt} />
								</SwiperSlide>
							))}
						</Swiper>
					</div>
				</div>

				<div className="male-section">
					<div
						className="gender-category male"
						style={{
							backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.60), rgba(0, 0, 0, 0.60)), url(${WaveBg})`,
							backgroundSize: 'cover',
							backgroundPosition: 'center'
						}}>
						{/* <MenIcon /> */}
						<img src={menIcon} width={200} height={200} alt="brr" />
					</div>
					<div className="content-wrapper">
						<div className="offers">
							<div className="offer">
								<div className="offer-information">
									<h2>
										<small>Ανδρικά Αθλητικά Παπούτσια</small>
										<Link
											to={
												'https://www.sportistas.com/el/search-results?searchquery=ASICS&size=120&f%3Aflags=New+Arrival&sort=auto_min_price&f%3Aattributes%7C%CE%95%CE%99%CE%94%CE%9F%CE%A3=%CE%A0%CE%91%CE%A0%CE%9F%CE%A5%CE%A4%CE%A3%CE%99%CE%91&f%3Abrand=ASICS'
											}>
											<Button color="light" outline>
												ΔΕΣ ΠΕΡΙΣΣΟΤΕΡΑ
											</Button>
										</Link>
									</h2>
								</div>
								<div className="image">
									<img src={menShoes} alt="men shoes" />
								</div>
							</div>
							<div className="offer">
								<div className="image">
									<img src={menSneakers} alt="men shoes" />
								</div>
								<div className="offer-information">
									<h2>
										<small>Ανδρικά Αθλητικά Παπούτσια</small>
										<Link to={'https://www.sportistas.com/el/search-results?searchquery=REEBOK&f%3Aflags=New+Arrival&size=120'}>
											<Button color="light" outline>
												ΔΕΣ ΠΕΡΙΣΣΟΤΕΡΑ
											</Button>
										</Link>
									</h2>
								</div>
							</div>
							<div className="offer">
								<div className="offer-information">
									<h2>
										<small>Ανδρικά Pούχα</small>
										<Link to={'https://www.sportistas.com/el/categories/brand?q=status%3ABlack+Offer%7Ecategory%3AASICS&page=1'}>
											<Button color="light" outline>
												ΔΕΣ ΠΕΡΙΣΣΟΤΕΡΑ
											</Button>
										</Link>
									</h2>
								</div>
								<div className="offer-image">
									<img src={menClothes} alt="men shoes" style={{ borderRadius: '50%', objectFit: 'cover' }} />
								</div>
								<div className="brand-image">
									<img src={asicsBrand} alt="asics" />
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="female-section">
					<div
						className="gender-category female"
						style={{
							backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.60), rgba(0, 0, 0, 0.60)), url(${WaveBg})`,
							backgroundSize: 'cover',
							backgroundPosition: 'center'
						}}>
						<img src={womenIcon} width={390} height={200} alt="brr" />
					</div>
					<div className="content-wrapper">
						<div className="offers">
							<div className="offer">
								<div className="offer-information">
									<h2>
										<small>Γυναικεία Αθλητικά Παπούτσια</small>
										<Link
											to={
												'https://www.sportistas.com/el/search-results?searchquery=ASICS&size=120&f%3Aflags=New+Arrival&sort=auto_min_price&f%3Aattributes%7C%CE%95%CE%99%CE%94%CE%9F%CE%A3=%CE%A0%CE%91%CE%A0%CE%9F%CE%A5%CE%A4%CE%A3%CE%99%CE%91&f%3Abrand=ASICS'
											}>
											<Button color="light" outline>
												ΔΕΣ ΠΕΡΙΣΣΟΤΕΡΑ
											</Button>
										</Link>
									</h2>
								</div>
								<div className="image">
									<img src={womenShoes} alt="men shoes" />
								</div>
							</div>
							<div className="offer">
								<div className="image">
									<img src={womenShoes2} alt="men shoes" />
								</div>
								<div className="offer-information">
									<h2>
										<small>Γυναικεία Αθλητικά Παπούτσια</small>
										<Link
											to={
												'https://www.sportistas.com/el/search-results?searchquery=ASICS&size=120&f%3Aflags=New+Arrival&sort=auto_min_price&f%3Aattributes%7C%CE%95%CE%99%CE%94%CE%9F%CE%A3=%CE%A0%CE%91%CE%A0%CE%9F%CE%A5%CE%A4%CE%A3%CE%99%CE%91&f%3Abrand=ASICS'
											}>
											<Button color="light" outline>
												ΔΕΣ ΠΕΡΙΣΣΟΤΕΡΑ
											</Button>
										</Link>
									</h2>
								</div>
							</div>
							<div className="offer">
								<div className="offer-information">
									<h2>
										<small>Γυναικεία Αθλητικά Παπούτσια</small>
										<Link
											to={
												'https://www.sportistas.com/el/search-results?searchquery=ASICS&size=120&f%3Aflags=New+Arrival&sort=auto_min_price&f%3Aattributes%7C%CE%95%CE%99%CE%94%CE%9F%CE%A3=%CE%A0%CE%91%CE%A0%CE%9F%CE%A5%CE%A4%CE%A3%CE%99%CE%91&f%3Abrand=ASICS'
											}>
											<Button color="light" outline>
												ΔΕΣ ΠΕΡΙΣΣΟΤΕΡΑ
											</Button>
										</Link>
									</h2>
								</div>
								<div className="image">
									<img src={womenShoes3} alt="men shoes" />
								</div>
							</div>
							<div className="offer">
								<div className="brand-image">
									<img src={asicsBrand} alt="asics" />
								</div>
								<div className="offer-image">
									<img src={womenClothes} alt="men shoes" style={{ borderRadius: '50%', objectFit: 'cover' }} />
								</div>
								<div className="offer-information">
									<h2>
										<small>Γυναικεία Pούχα</small>
										<Link
											to={
												'https://www.sportistas.com/el/search-results?searchquery=REEBOK&f%3Aflags=Black+Offer&sort=auto_min_price&size=120&dir=asc'
											}>
											<Button color="light" outline>
												ΔΕΣ ΠΕΡΙΣΣΟΤΕΡΑ
											</Button>
										</Link>
									</h2>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="child-section">
					<div
						className="gender-category-child male"
						style={{
							backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.60), rgba(0, 0, 0, 0.60)), url(${WaveBg})`,
							backgroundSize: 'cover',
							backgroundPosition: 'center'
						}}>
						<img src={kidsIcon} width={200} height={200} alt="brr" />
					</div>
					<div className="content-wrapper">
						<div className="offers">
							<div className="offer">
								<div className="offer-image">
									<img src={kidsShoes1} alt="kid shoes" />
								</div>
								<div className="offer-information">
									<h2>
										<small>Παιδικά Παπούτσια</small>
										<Link to={'https://www.sportistas.com/el/search-results?searchquery=REEBOK&f%3Aflags=New+Arrival&size=120'}>
											<Button color="light" outline>
												ΔΕΣ ΠΕΡΙΣΣΟΤΕΡΑ
											</Button>
										</Link>
									</h2>
								</div>
							</div>

							<div className="offer">
								<div className="offer-image">
									<img src={kidsShoes2} alt="kid shoes" />
								</div>
								<div className="offer-information">
									<h2>
										<small>Παιδικά Παπούτσια</small>
										<Link
											to={
												'https://www.sportistas.com/el/search-results?searchquery=ASICS&size=120&f%3Aflags=New+Arrival&sort=auto_min_price&f%3Aattributes%7C%CE%95%CE%99%CE%94%CE%9F%CE%A3=%CE%A0%CE%91%CE%A0%CE%9F%CE%A5%CE%A4%CE%A3%CE%99%CE%91&f%3Abrand=ASICS'
											}>
											<Button color="light" outline>
												ΔΕΣ ΠΕΡΙΣΣΟΤΕΡΑ
											</Button>
										</Link>
									</h2>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="content-wrapper">
					<div className="top-brands-section">
						<h2>Top Brands σε BF τιμές</h2>
						<div className="brands-images">
							<img src={asicsBrand} alt="asics" />
							<img src={speedoBrand} alt="speedo" />
							<img src={tevaBrand} alt="teva" />
							<img src={oneilBrand} alt="oneil" />
							<img src={reebokLogo} alt="reebok" />
						</div>
					</div>
					<div className="why-us">
						<h2>
							<b>
								Γιατί <span>SPORTISTAS </span>
							</b>
							<span>στη Black Friday;</span>
						</h2>
						<div className="container">
							{whyItems.map((x, index) => (
								<div key={index} className="item">
									{x.img}
									<b>{x.title}</b>
									<span>{x.description}</span>
								</div>
							))}
						</div>
					</div>
				</div>

				<div className="faq-banner">
					<div className="faq-icon">
						<FaqIcon />
					</div>
					<div className="faq-background">
						<h2 className="faq-title">Black Friday FAQs</h2>
						<p className="faq-description">Βρες τις απαντήσεις σε όλα τα… Black Friday ερωτήματά σου!</p>
					</div>
				</div>

				<div className="content-wrapper">
					<div className="faq">
						<div className="questions">
							{htmlFaqs.map((x, index) => (
								<div
									className={`question ${activeQuestion === index ? 'active' : ''}`}
									key={index}
									onClick={() => setActiveQuestion(activeQuestion === index ? null : index)}>
									<div className="heading">
										<h3 className="title">{x.question}</h3>
										<button aria-label={`"open ${x.question}"`}>
											<ArrowIcon />
										</button>
									</div>
									<div className="content">{x.answer}</div>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default BlackFriday;
